<template>
  <el-container class="login-container">
    <el-header class="login-header">训练管理系统</el-header>
    <el-main class="login-main">
      <el-form ref="loginForm" class="login-form" :model="loginForm" :rules="rules" label-width="150px">
        <div class="login-form-title">请登录</div>
        <el-form-item label="账号/手机号" prop="username">
          <el-input v-model="loginForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" @keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item label="记住密码" prop="remember">
          <el-switch v-model="loginForm.remember"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  mounted () {
    this.loginForm.username = localStorage.getItem('kaochang.username')
    this.loginForm.password = localStorage.getItem('kaochang.password')
    this.loginForm.remember = (localStorage.getItem('kaochang.remember') === 'true')
  },
  methods: {
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$http.post('/auth/login', {
            ...this.loginForm
          }).then((response) => {
            this.loading = false
            if (response.data.success) {
              let user = response.data.user
              localStorage.setItem('kaochang.token', user.token)
              localStorage.setItem('kaochang.username', this.loginForm.username)
              localStorage.setItem('kaochang.remember', this.loginForm.remember)
              if (this.loginForm.remember) {
                localStorage.setItem('kaochang.password', this.loginForm.password)
              } else {
                localStorage.removeItem('kaochang.password')
              }
              this.$http.defaults.headers.common['token'] = user.token
              if (user.expiry_date && parseInt((new Date(user.expiry_date).getTime() - Date.now())/1000/3600/24) <= -1) {
                // this.$router.replace('/pay')
                this.$router.replace('/expiry')
              // } else if (user.group_id == 5 || user.group_id == 22) {
              //   this.$router.replace('/expiry')
              } else {
                // let path = this.$route.query.redirect
                // if (!path) {
                  location.href = '/'
                // } else {
                //   location.href = decodeURIComponent(path)
                // }
              }
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: #F7F7F7;
}
.login-header {
  background: #ededed;
  border-bottom: 1px solid #d9dee4;
  text-align: center;
  height: 50px !important;
  line-height: 50px;
  font-size: 18px;
  font-weight: 400;
}
.login-main {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-form {
  width: 420px;
  background: #fff;
  padding-right: 30px;
  border: 1px solid #d9dee4;
}
.login-form-title {
  font-size: 24px;
  font-weight: 500;
  padding: 20px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue